import request from '@/utils/request'

export function enrollInfoDetail(data) {
	return request({
		url: '/enroll-info/detail',
		method: 'post',
		headers: { 'oper': '用户报名主信息获取', 'oper-type': 1032 },
		data
	})
}
export function EnrollInfoListPage(data) {
	return request({
		url: '/enroll-info/list-page',
		method: 'post',
		headers: { 'oper': '用户报名列表获取', 'oper-type': 1033 },
		data
	})
}
export function enrollInfoAdd(data) {
	return request({
		url: '/enroll-info/add',
		method: 'post',
		headers: { 'oper': '保存用户主信息', 'oper-type': 1034 },
		data
	})
}
export function enrollInfoUpdate(data,tip = true) {
	return request({
		url: '/enroll-info/update',
		method: 'post',
		headers: { 'oper': '用户主信息更新', 'oper-type': 1035 },
		tip,
		data
	})
}
export function areaList(data) {
	return request({
		url: '/area/simple-list',
		method: 'post',
	headers: { 'oper': '获取地区', 'oper-type': 1036 },
		data
	})
}

export function enrollStudAdd(data) {
	return request({
		url: '/enroll-stud/add',
		method: 'post',
	headers: { 'oper': '保存在读学历', 'oper-type': 1037 },
		data
	})
}
export function enrollStudDetail(data) {
	return request({
		url: '/enroll-stud/last-enroll-stud-detail',
		method: 'post',
	headers: { 'oper': '在读学历获取', 'oper-type': 1038 },
		data
	})
}
export function enrollStudUpdate(data) {
	return request({
		url: '/enroll-stud/update',
		method: 'post',
	headers: { 'oper': '在读学历更新', 'oper-type': 1039 },
		data
	})
}
export function EnrollGradAdd(data) {
	return request({
		url: '/enroll-grad/add',
		method: 'post',
	headers: { 'oper': '最高学历添加', 'oper-type': 1040 },
		data
	})
}
export function EnrollGradDetail(data) {
	return request({
		url: '/enroll-grad/last-enroll-grad-detail',
		method: 'post',
	headers: { 'oper': '最高学历查看', 'oper-type': 1041 },
		data
	})
}
export function EnrollGradUpdate(data) {
	return request({
		url: '/enroll-grad/update',
		method: 'post',
	headers: { 'oper': '最高学历更新', 'oper-type': 1042 },
		data
	})
}
export function enrollCompanyAdd(data) {
	return request({
		url: '/enroll-company/add',
		method: 'post',
	headers: { 'oper': '工作经历添加', 'oper-type': 1043 },
		data
	})
}
export function lastEnrollComdetail(data) {
	return request({
		url: '/enroll-company/list',
		method: 'post',
	headers: { 'oper': '工作经历获取', 'oper-type': 1044 },
		data
	})
}
export function enrollCompanyUpdate(data) {
	return request({
		url: '/enroll-company/update',
		method: 'post',
	headers: { 'oper': '工作经历更新', 'oper-type': 1045 },
		data
	})
}
export function enrollCompanyUpdateone(data,tip = true) {
	return request({
		url: '/enroll-company/update-one',
		method: 'post',
	headers: { 'oper': '工作经历更新一个', 'oper-type': 1046 },
		tip,
		data
	})
}
export function EnrollCertAdd(data) {
	return request({
		url: '/enroll-cert/add',
		method: 'post',
	headers: { 'oper': '工作证书添加', 'oper-type': 1047 },
		data
	})
}
export function EnrollCertList(data) {
	return request({
		url: '/enroll-cert/list',
		method: 'post',
	headers: { 'oper': '工作证书获取', 'oper-type': 1048 },
		data
	})
}
export function EnrollCertUpdate(data) {
	return request({
		url: '/enroll-cert/update',
		method: 'post',
	headers: { 'oper': '工作证书更新', 'oper-type': 1049 },
		data
	})
}
export function EnrollCommendAdd(data) {
	return request({
		url: '/enroll-commend/add',
		method: 'post',
	headers: { 'oper': '推荐信添加', 'oper-type': 1050 },
		data
	})
}
export function ErollCommendList(data) {
	return request({
		url: '/enroll-commend/list',
		method: 'post',
	headers: { 'oper': '推荐信获取', 'oper-type': 1051 },
		data
	})
}
export function EnrollCommendUpdate(data) {
	return request({
		url: '/enroll-commend/update',
		method: 'post',
		headers: { 'oper': '推荐信更新', 'oper-type': 1052 },
		data
	})
}
export function EnrollInfoDetailAll(data) {
	return request({
		url: '/enroll-info/detail-all',
		method: 'post',
		headers: { 'oper': '报名所有信息预览', 'oper-type': 1053 },
		data
	})
}
export function EnrollExamAdd(data) {
	return request({
		url: '/enroll-exam/add',
		method: 'post',
		headers: { 'oper': '报名地区选择', 'oper-type': 1054 },
		data
	})
}
export function examTimeList(data) {
	return request({
		url: '/exam/time-list',
		method: 'post',
		headers: { 'oper': '报名时间获取', 'oper-type': 1055 },
		data
	})
}
export function listArea(data) {
	return request({
		url: '/exam-room/list-area',
		method: 'post',
		headers: { 'oper': '报名地区获取', 'oper-type': 1056 },
		data
	})
}
export function examList(data) {
	return request({
		url: 'exam/list',
		method: 'post',
		headers: { 'oper': '报名列表', 'oper-type': 1057 },
		data
	})
}

//考试时间发布
export function examTime(data) {
	return request({
		url: 'exam/add',
		method: 'post',
		headers: { 'oper': '考试时间发布', 'oper-type': 1058 },
		data
	})
}

//考场发布
export function examRoom(data) {
	return request({
		url: 'exam-room/add',
		method: 'post',
		headers: { 'oper': '考场发布', 'oper-type': 1058 },
		data
	})
}

//准考证列表
export function permitList(data) {
	return request({
		url: 'permit/list',
		method: 'post',
		headers: { 'oper': '准考证列表', 'oper-type': 1059 },
		data
	})
}

//准考证详情
export function permitDetail(data) {
	return request({
		url: 'permit/detail',
		method: 'post',
		headers: { 'oper': '准考证详情', 'oper-type': 1060 },
		data
	})
}

//成绩管理列表
export function roomResultList(data) {
	return request({
		url: 'room-result/list',
		method: 'post',
		headers: { 'oper': '成绩管理列表', 'oper-type': 1061	 },
		data
	})
}

//考场成绩查看詳情
export function roomResultDetail(data) {
	return request({
		url: 'room-result/detail',
		method: 'post',
		headers: { 'oper': '考场成绩查看詳情', 'oper-type': 1062 },
		data
	})
}

//考场成绩发布  
export function examResultAdd(data) {
	return request({
		url: 'exam-result/add',
		method: 'post',
		headers: { 'oper': '考场成绩发布', 'oper-type': 1063 },
		data
	})
}

//  
export function roomResultDelete(data) {
	return request({
		url: 'room-result/delete',
		method: 'post',
		headers: { 'oper': '考场删除', 'oper-type': 1064 },
		data
	})
}

//考场成绩审核 
export function roomResultCheck(data) {
	return request({
		url: 'room-result/check',
		method: 'post',
		headers: { 'oper': '考场成绩审核', 'oper-type': 1065 },
		data
	})
}

//考场成绩修改 
export function examResultUpdate(data) {
	return request({
		url: 'exam-result/update',
		method: 'post',
		headers: { 'oper': '考场成绩修改', 'oper-type': 1066 },
		data
	})
}

export function orderPrePay(data) {
	return request({
		url: '/order/pre_pay',
		headers: { 'oper': '支付预调用', 'oper-type': 1067 },
		method: 'post',
		tip: false,
		data
	})
}

export function enrollcodeCodeUsed(data) {
	return request({
		url: '/org-enrollcode/code-used',
		headers: { 'oper': '报名码使用', 'oper-type': 1068 },
		method: 'post',
		data
	})
}

export function examRoomDetail(data) {
	return request({
		url: '/exam-room/detail',
		headers: { 'oper': '考场信息', 'oper-type': 1069 },
		method: 'post',
		data
	})
}

export function delayedEnroll(data) {
	return request({
		url: '/enroll-info/delayed-enroll',
		headers: { 'oper': '申请延期', 'oper-type': 1070 },
		method: 'post',
		data
	})
}

export function confirmExamRoom(data) {
	return request({
		url: '/enroll-exam/confirm-exam-room',
		headers: { 'oper': '确认考场', 'oper-type': 1071 },
		method: 'post',
		data
	})
}

export function examDetail(data) {
	return request({
		url: '/exam-user/exam-detail',
		headers: { 'oper': '考试考场信息', 'oper-type': 1072 },
		method: 'post',
		data
	})
}

export function makeUpEnroll(data) {
	return request({
		url: '/enroll-info/make-up-enroll',
		headers: { 'oper': '申请补考', 'oper-type': 1073 },
		method: 'post',
		data
	})
}
export function ifEnroll(data) {
	return request({
		url: '/enroll-info/if-enroll',
		headers: { 'oper': '报名审查', 'oper-type': 1074 },
		method: 'post',
		data
	})
}
